import { salestransaction } from "../json/salesdashboardrecenttranscation";
import { unitsdata } from "../json/unitsdata";
import { variantattributesdata } from "../json/variantattributesdata";
import { warrentydata } from "../json/waarrentydata";
import { shiftlistdata } from "../json/shiftlistdata";
import { salersretrunsdata } from "../json/salesreturn";
import { quotationlistdata } from "../json/quotationlistdata";
import { SupplierData } from "../json/supplier_data";
import { StockTransferData } from "../json/stocktransferdata";
import { userlisadata } from "../json/users";
import { rolesandpermission } from "../json/rolesandpermissiondata";
import { subcateorydata } from "../json/subcategorydata";

//region rollcall
import { rollcallregistrationlistdata } from "../json/rollcallregistrationlistdata";
import { rollcallrejoinemployeelistdata } from "../json/rollcallrejoinemployeelistdata";
import { rollcallemployeeslistdata } from "../json/rollcallemployeeslistdata";
import { rollcallmanualattendancelistdata } from "../json/rollcallmanualattendancelistdata";

// import { rollcalldepartmentstdata } from "../json/rollcalldepartmentsdata";
import { rollcallemployeesaccessdata } from "../json/rollcallemployeesaccesdata";
import { rollcallassignshiftsdata } from "../json/rollcallassignshiftsdata";

//region Inventory

import { rollcallLeaveDetails } from "../json/rollcallleavedetails";
import { RollcallAttaedanceInOutReport } from "../json/rollcallattendanceinoutreport";
import { RollcallPunchesDayByDayReports } from "../json/rollcallpunchesdaybydayreports";
import { RollcallMonthlySummaryreport } from "../json/rollcallmonthlysummaryreport";
import { RollCallBreakSummaryReport } from "../json/rollcallbreaksummaryreports";
import { RollCallBreakdetailsreports } from "../json/rollcallbreakdetailsreport";
import { RollCallDailyAttedanceReport } from "../json/rollcalldailyattendancereports";
import { rollcallholidayslistdata } from "../json/rollcallholidayslistdata";
import { rollcallleaveaccurals } from "../json/rollcallleaveaccurals";
import { rollcallleavesummary } from "../json/rollcallleavesummary";
import { rollcallleavetypes } from "../json/rollcallleavetypes";

const { productlistdata } = require("../json/productlistdata");

const initialState = {
  product_list: productlistdata,

  saleshdashboard_recenttransaction: salestransaction,
  unit_data: unitsdata,
  variantattributes_data: variantattributesdata,
  warranty_data: warrentydata,

  shiftlist_data: shiftlistdata,
  toggle_header: false,
  salesreturns_data: salersretrunsdata,
  quotationlist_data: quotationlistdata,
  supplierdata: SupplierData,
  stocktransferdata: StockTransferData,
  userlist_data: userlisadata,
  rolesandpermission_data: rolesandpermission,

  subcategory_data: subcateorydata,
  layoutstyledata: localStorage.getItem("layoutStyling"),

  //region pereco

  //region Rollcall

  rollcall_registration_list: rollcallregistrationlistdata,
  rollcall_rejoinemployees_list: rollcallrejoinemployeelistdata,
  rollcall_employees_list: rollcallemployeeslistdata,
  rollcall_manual_attendanceList: rollcallmanualattendancelistdata,

  departmentList: [],
  rollcall_holidays: rollcallholidayslistdata,
  rollcall_employees_accessList: rollcallemployeesaccessdata,
  rollcall_assignshifts_list: rollcallassignshiftsdata,
  rollcall_Leave_Details: rollcallLeaveDetails,
  Rollcall_Attaedance_InOut_Report: RollcallAttaedanceInOutReport,
  Rollcall_Monthly_Summary_report: RollcallMonthlySummaryreport,
  Rollcall_Punches_DayByDay_Reports: RollcallPunchesDayByDayReports,
  RollCall_Break_Summary_Report: RollCallBreakSummaryReport,
  RollCall_Break_details_reports: RollCallBreakdetailsreports,
  RollCall_Daily_Attedance_Report: RollCallDailyAttedanceReport,
  rollcall_leave_accurals: rollcallleaveaccurals,
  rollcall_leave_summary: rollcallleavesummary,
  rollcall_leave_types: rollcallleavetypes,
};

export default initialState;
